// common/services/player/updateFamilyContact.ts
import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

export type UpdateFamilyContactInput = {
  /** Player whose family the contact belongs to. */
  playerId: string
  /** The contact being edited. */
  contactId: string
  /** Given name for the contact. */
  name_first: string
  /** Family name for the contact. */
  name_last: string
  email: string
  /** E.164 phone number (e.g. '+14165550123'). Optional per the design. */
  phone_number?: string | null
  /** BE relationship type id (RelationshipType). Null clears/omits it. */
  relationship_type_id?: number | null
  /** Whether the contact gets administrative access to the player. */
  is_primary?: boolean
}

export type UpdateFamilyContactResponse = {
  id?: string
  status?: 'updated' | 'pending'
} & Record<string, unknown>

/**
 * PUT /players/:playerId/family/:contactId — updates an existing family
 * contact's profile. Body mirrors inviteFamilyContact (minus the contactId
 * itself which is in the path).
 */
export const updateFamilyContact = async (
  input: UpdateFamilyContactInput
): Promise<UpdateFamilyContactResponse> => {
  const { playerId, contactId, ...body } = input
  const { data } = await req(
    ENDPOINTS.PLAYERS.UPDATE_PLAYER_FAMILY_CONTACT(playerId, contactId),
    { method: 'PUT', body: JSON.stringify(body) }
  )
  return data as UpdateFamilyContactResponse
}
